import Service from "../../../../utils/api/service";
import Media from "./../../../../components/share/media";
import Multiselect from "vue-multiselect";
import _debounce from "lodash.debounce";

export default {
  name: "CreateCategory",
  data() {
    return {
      isCreating: false,
      display: {
        imagePreview: false,
        media: false,
      },
      body: {
        image: {
          file: "",
          presign: "",
        },
        img: "",
        name: "",
        nameKh: "",
        sortOrder: 0,
        parentId: 0,
        subId: 0,
        status: "active",
        brandIds: [],
      },
      data: {
        categoryList: this.$master?.categories || [],
      },
      loading: {
        isCreating: false,
        isSearching: false,
      },
      items: this.$master?.brands || [],
      allItems: this.$master?.brands || [],
      brandIds: [],
      debouncedOnSearchItems: null,
    };
  },
  components: {
    Media,
    Multiselect,
  },
  computed: {},
  created() {
    this.debouncedOnSearchItems = _debounce(this.handleItemsSearchChange, 500);
  },
  methods: {
    onSelectCat() {
      if (!this.body.parentId) return;

      this.brandIds = [];
      this.filterItems(this.items, "");
    },

    handleItemsSearchChange(query) {
      if (!query || query.trim() === "") {
        this.items = [...this.allItems];
        return;
      }

      this.filterItems(this.allItems, query);
    },

    filterItems(data, search) {
      if (!search || search.trim() === "") {
        this.items = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.items = items;
    },

    goBack() {
      this.$router.push({
        name: "ListCategory",
        query: {
          page: 1,
          limit: 10,
        },
      });
    },

    closeModal() {
      this.display = {
        imagePreview: false,
        media: false,
      };
    },

    imagePreview() {
      if (this.body.image.file || this.data.media) {
        this.display.imagePreview = true;
      }
    },

    chooseImage() {
      this.display.media = true;
    },

    existedMediaCallback(media) {
      this.data.media = media;
      this.closeModal();
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getNameFromUrl(url) {
      return url.split("/").pop();
    },

    fileToPath(file) {
      return window.URL.createObjectURL(file);
    },

    submitCreateCategory() {
      let validatedMessage = this.validateBody(this.body);
      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.createCategory();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      // else if (this.brandIds && !this.brandIds.length && data?.parentId) {
      //   return "Brand cannot be empty!";
      // } 

      if (!(data.image.file || (this.data.media && this.data.media.url))) {
        return "Image file cannot be empty!";
      } else if (!data.name) {
        return "Name cannot be empty!";
      } else if (!data.nameKh) {
        return "Name KH cannot be empty!";
      } else if (!data.subId) {
        return "SubId cannot be empty!";
      } else if (!data.status) {
        return "Status order cannot be empty!";
      } else {
        return "ok";
      }
    },

    createCategory() {
      let image = "";
      if (this.data.media && this.data.media.url) {
        image = this.data.media.url;
      }

      const body = {
        parentId: parseInt(this.body.parentId),
        name: this.body.name,
        nameKh: this.body.nameKh,
        imageUrl: image,
        sortOrder: this.body.sortOrder ? this.body.sortOrder : 0,
        status: this.body.status,
        subId: parseInt(this.body.subId),
        brandIds: this.brandIds.map((item) => item.id),
      };
      body.brandIds && !body.brandIds.length && delete body.brandIds;

      Service.createCategory(body).then((response) => {
        this.isCreating = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.createCategory();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.resetBody();
          this.$toasted.show("Category has been created.");
        }
      });
    },

    resetBody() {
      this.body = {
        image: {
          file: "",
          presign: "",
        },
        img: "",
        name: "",
        nameKh: "",
        sortOrder: 0,
        status: "active",
        brandIds: [],
      };

      this.brandIds = [];
      this.data.media = {};
    },
  },
};
